export const deviceTemplates = [
  {
    label: "2n",
    options: ["2n/ipbase", "2n/ipone", "2n/ipsolo", "2n/ipverso", "2n/style", "2n/verso2"],
  },
  {
    label: "aastra",
    options: ["aastra/480i", "aastra/673x", "aastra/675x", "aastra/686x", "aastra/9112i", "aastra/9133i"],
  },
  {
    label: "acrobits",
    options: ["acrobits/default"],
  },
  {
    label: "algo",
    options: ["algo/8103", "algo/8180", "algo/8196"],
  },
  {
    label: "atcom",
    options: ["atcom/ag198"],
  },
  {
    label: "audiocodes",
    options: [],
  },
  {
    label: "avaya",
    options: ["avaya/J139", "avaya/J169", "avaya/J179", "avaya/J189"],
  },
  {
    label: "bittel",
    options: [],
  },
  {
    label: "cisco",
    options: [
      "cisco/7940",
      "cisco/7960",
      "cisco/79x1",
      "cisco/8811",
      "cisco/8832",
      "cisco/8841",
      "cisco/8845",
      "cisco/8851",
      "cisco/8861",
      "cisco/8865",
      "cisco/9861",
      "cisco/spa112",
      "cisco/spa122",
      "cisco/spa191",
      "cisco/spa192",
      "cisco/spa301",
      "cisco/spa303",
      "cisco/spa501g",
      "cisco/spa502g",
      "cisco/spa504g",
      "cisco/spa508g",
      "cisco/spa509g",
      "cisco/spa512g",
      "cisco/spa514g",
      "cisco/spa525g",
      "cisco/spa525g2",
    ],
  },
  {
    label: "digium",
    options: [
      "digium/d40",
      "digium/d50",
      "digium/d60",
      "digium/d62",
      "digium/d65",
      "digium/d70",
    ],
  },
  {
    label: "escene",
    options: ["escene/e3xx"],
  },
  {
    label: "escene programmable",
    options: [],
  },
  {
    label: "fanvil",
    options: [
      "fanvil/h2u-v2",
      "fanvil/h5",
      "fanvil/i30",
      "fanvil/v67",
      "fanvil/x1s",
      "fanvil/x1sg",
      "fanvil/x1sp",
      "fanvil/x210",
      "fanvil/x2p",
      "fanvil/x3g",
      "fanvil/x3sg",
      "fanvil/x3sp",
      "fanvil/x3sw",
      "fanvil/x3u",
      "fanvil/x3u-pro",
      "fanvil/x4",
      "fanvil/x4g",
      "fanvil/x4sg",
      "fanvil/x4u",
      "fanvil/x5s",
      "fanvil/x5u",
      "fanvil/x6",
      "fanvil/x6u",
      "fanvil/x7",
      "fanvil/x7a",
      "fanvil/x7c",
    ],
  },
  {
    label: "flyingvoice",
    options: [
      "flyingvoice/audiokit",
      "flyingvoice/fip10",
      "flyingvoice/fip11c",
      "flyingvoice/fip12wp",
      "flyingvoice/fip13g",
      "flyingvoice/fip14g",
      "flyingvoice/fip15g",
      "flyingvoice/fip16",
      "flyingvoice/fip16plus",
      "flyingvoice/i86box",
      "flyingvoice/imetalbox",
      "flyingvoice/p10",
      "flyingvoice/p10g",
      "flyingvoice/p10lte",
      "flyingvoice/p10p",
      "flyingvoice/p10w",
      "flyingvoice/p11",
      "flyingvoice/p11g",
      "flyingvoice/p11lte",
      "flyingvoice/p11p",
      "flyingvoice/p11w",
      "flyingvoice/p20",
      "flyingvoice/p20g",
      "flyingvoice/p20p",
      "flyingvoice/p20w",
      "flyingvoice/p21",
      "flyingvoice/p21p",
      "flyingvoice/p21w",
      "flyingvoice/p22g",
      "flyingvoice/p22p",
      "flyingvoice/p23g",
      "flyingvoice/p23gw",
      "flyingvoice/p24gw",
      "flyingvoice/p33",
      "flyingvoice/p33g",
      "flyingvoice/p33p",
      "flyingvoice/p510",
      "flyingvoice/p53",
      "flyingvoice/p54",
      "flyingvoice/p55",
      "flyingvoice/p57",
      "flyingvoice/p58",
    ],
  },
  {
    label: "grandstream",
    options: [
      "grandstream/dp715",
      "grandstream/dp715.sm",
      "grandstream/dp750",
      "grandstream/gac2500",
      "grandstream/gds3705",
      "grandstream/gds3710",
      "grandstream/ghp6xx",
      "grandstream/grp2612",
      "grandstream/grp2612w",
      "grandstream/grp2613",
      "grandstream/grp2614",
      "grandstream/grp2615",
      "grandstream/grp2616",
      "grandstream/grp261x",
      "grandstream/grp26xx",
    ],
  },
  {
    label: "linphone",
    options: ["linphone/default"],
  },
  {
    label: "mobile",
    options: ["mobile/android", "mobile/ios"],
  },
  {
    label: "mizu",
    options: ["mizu/default"],
  },
  {
    label: "mizuphone",
    options: ["mizuphone/default"],
  },
  {
    label: "polycom",
    options: [
      "polycom/vvx201",
      "polycom/vvx301",
      "polycom/vvx311",
      "polycom/vvx401",
      "polycom/vvx411",
      "polycom/vvx501",
      "polycom/vvx601",
    ],
  },
  {
    label: "snom",
    options: ["snom/300", "snom/320", "snom/360", "snom/370", "snom/821"],
  },
  {
    label: "softphone",
    options: ["softphone/default"],
  },
  {
    label: "yealink",
    options: [
      "yealink/t19p",
      "yealink/t21p",
      "yealink/t23p",
      "yealink/t27p",
      "yealink/t29g",
      "yealink/t31p",
      "yealink/t32g",
      "yealink/t33p",
      "yealink/t38g",
      "yealink/t40p",
      "yealink/t41p",
      "yealink/t42p",
      "yealink/t46g",
      "yealink/t48g",
      "yealink/t54w",
      "yealink/t55a",
      "yealink/t56a",
      "yealink/t58a",
      "yealink/t58w",
      "yealink/t59p",
      "yealink/t62a",
      "yealink/t63a",
      "yealink/t64g",
      "yealink/t65p",
      "yealink/t66p",
      "yealink/t67p",
      "yealink/t68p",
    ],
  },
];

export const deviceKeyTypes = [
  {
    label: "Aastra",
    options: [
      "aastra/blf",
      "aastra/list",
      "aastra/blfxfer",
      "aastra/callers",
      "aastra/callforward",
      "aastra/conf",
      "aastra/directory",
      "aastra/dnd",
      "aastra/empty",
      "aastra/filter",
      "aastra/flash",
      "aastra/icom",
      "aastra/lcr",
      "aastra/line",
      "aastra/none",
      "aastra/paging",
      "aastra/park",
      "aastra/phonelock",
      "aastra/pickup",
      "aastra/redial",
      "aastra/speeddial",
      "aastra/speeddialconf",
      "aastra/speeddialmwi",
      "aastra/speeddialxfer",
      "aastra/sprecode",
      "aastra/xfer",
      "aastra/xml"
    ]
  },

  {
    label: "Audiocodes",
    options: [
      "audiocodes/SPEED_DIAL_BLF",
      "audiocodes/PAGING",
      "audiocodes/SPEED_DIAL"
    ]
  },

  {
    label: "Avaya",
    options: [
      "avaya/autoanswer",
      "avaya/autodial",
      "avaya/blf",
      "avaya/callfwd",
      "avaya/callfwdbusy",
      "avaya/callfwdna",
      "avaya/dnd",
      "avaya/primary",
      "avaya/lock",
      "avaya/screensaver",
      "avaya/sca"
    ]
  },

  {
    label: "Cisco",
    options: [
      "cisco/blf",
      "cisco/disabled",
      "cisco/line",
      "cisco/shared"
    ]
  },

  {
    label: "Digium",
    options: [
      "digium/blf",
      "digium/calllog",
      "digium/conference",
      "digium/dnd",
      "digium/forward",
      "digium/hold",
      "digium/park",
      "digium/parking",
      "digium/pickup",
      "digium/redial",
      "digium/speed"
    ]
  }
];

